<template><!-- Mobile -->
    <section class="">
        <front-table :front_page="page"
                     :front_records="records"
                     :front_search="search"
                     :front_header="header"
                     :model="model"
                     @reload="handleReload"
                     @edit="handleEdit"
        >
        </front-table>
        <!--编辑界面-->
        <edit-dialog :edit_mode="edit_mode" :model="model" :single="single" :fields="fields" dual
                     @success="handleSuccess" @cancel="handleCancel"></edit-dialog>

        <div class="clearfix"></div>
    </section>
</template>

<script>
    import EditDialog from "../../components/edit-mobile-dialog";
    import FrontTable from "../../components/front-mobile-table";
    import FrontMixins from "../../common/mixins/front-mixins";

    export default {
        mixins: [FrontMixins],
        name: 'admin-admin',
        components: {FrontTable, EditDialog},
        created() {
            this.model =  'Admin.' + this.$route.meta.model;
        }
    }

</script>

<style lang="scss">

</style>
